import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useEffect, useState } from "react";
import { PaymentConfirmationView } from "./ui/view";
import { useDispatch } from "react-redux";
import { quoteOne, quoteOneClearData } from "../../store/generateQuote/actions";
import { PaymentConfirmationHeader } from "./ui/header";
import { useGetSteps } from "../../utils/getSteps";
import { policyConfirm, policyConfirmClearData, } from "../../store/policy/actions";
import { useNavigate, useParams } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { getDataFormFilters } from "./resources/paymentConfirmationDTO";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { STEP_PAYMENTCONFIRMATION } from "../../const/catalog";
import { formatToTwoDecimals } from "../../utils/getPrice";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import usePaymentConfirmation from "./components/paymentConfirmation";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { addToSummary } from "ah_utility/fnxUtils";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
var PaymentConfirmation = function () {
    var _a, _b, _c;
    var dispatch = useDispatch();
    var STEP = STEP_PAYMENTCONFIRMATION;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var steps2 = useGetSteps();
    var _d = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _d[0], setSeeToast = _d[1];
    var _e = useState(true), showModal = _e[0], setShowModal = _e[1];
    // Documents from the page's own quote request; the certificates section keeps polling on its own.
    var _f = useState(null), seedCertificates = _f[0], setSeedCertificates = _f[1];
    var quoteIdParam = useParams().quoteId;
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteId = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var quote_id = localStorage.getItem("Quote");
    var Policy = React.useState(findParamInLocalStorage("Policy"))[0];
    var policyId = Policy === null || Policy === void 0 ? void 0 : Policy.id;
    var company = React.useState(findParamInLocalStorage("subdomain"))[0];
    var actionFlags = findParamInLocalStorage("", "afy-action-flags");
    var isTravelInsurance = (_a = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (flag) { return flag.name === "afy-show-plan-travel-range-info"; })) !== null && _a !== void 0 ? _a : false;
    var User = React.useState(findParamInLocalStorage("user"))[0];
    // const email = User?.email;
    var _g = useState(""), email = _g[0], setEmail = _g[1];
    var _h = useState({}), dataForm = _h[0], setDataForm = _h[1];
    var _j = useSelectors(), responseQuote = _j.responseQuote, responseOneQuote = _j.responseOneQuote, responsePolicyConfirm = _j.responsePolicyConfirm, responsePolicyConfirmError = _j.responsePolicyConfirmError, responsePolicyConfirmLoading = _j.responsePolicyConfirmLoading, errorOneQuote = _j.errorOneQuote, loadingOneQuote = _j.loadingOneQuote;
    var _k = useUI(STEP, navigate, showModal, setShowModal, responseOneQuote, quoteIdParam), showSuccess = _k.showSuccess, handlePrevious = _k.handlePrevious, handleNext = _k.handleNext, handleDownload = _k.handleDownload;
    var handleSendEmail = usePaymentConfirmation(policyId, dispatch, policyConfirm).handleSendEmail;
    useEffect(function () {
        dispatch(quoteOne({ id: quoteId || quote_id || quoteIdParam, fullBody: true }));
        if (quoteIdParam) {
            showToastSuccessMessage("Método de pago actualizado con exitosamente.", typeAlert.success, setSeeToast);
        }
    }, []);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        if (responsePolicyConfirmError) {
            showErrorToast(responsePolicyConfirmError, setSeeToast, t);
        }
    }, [responsePolicyConfirmError]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a, _b;
        if (isTravelInsurance &&
            ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.data.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_c = (_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.contentMap) === null || _c === void 0 ? void 0 : _c.premium]);
    useEffect(function () {
        var _a;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var certs = (_a = responseOneQuote.data.certificates) !== null && _a !== void 0 ? _a : [];
            setSeedCertificates(certs.map(function (c) { return ({
                id: c.id,
                name: c.title,
                url: c.url,
                status: c.status,
            }); }));
            dispatch(quoteOneClearData());
        }
    }, [responseOneQuote]);
    useEffect(function () {
        if (responsePolicyConfirm && (responsePolicyConfirm === null || responsePolicyConfirm === void 0 ? void 0 : responsePolicyConfirm.data)) {
            setSeeToast({
                show: true,
                message: "Correo enviado con éxito",
                type: typeAlert.success,
            });
            dispatch(policyConfirmClearData());
        }
    }, [responsePolicyConfirm]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
        if ((responseQuote === null || responseQuote === void 0 ? void 0 : responseQuote.data) || (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var df = dataForm;
            df.Name = responseOneQuote
                ? "".concat((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.firstNameA, " ").concat((_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.firstNameB)
                : "".concat(responseQuote.data.firstNameA, " ").concat(responseQuote.data.firstNameB);
            df.LastNames = responseOneQuote
                ? "".concat((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.lastNameA, " ").concat((_d = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _d === void 0 ? void 0 : _d.lastNameB)
                : "".concat(responseQuote.data.lastNameA, " ").concat(responseQuote.data.lastNameB);
            df.DocumentNumber = responseOneQuote
                ? "".concat((_e = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.numberId)
                : "".concat(responseQuote.data.numberId);
            df.Insurance = responseOneQuote
                ? "".concat((_g = (_f = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _f === void 0 ? void 0 : _f.productId) === null || _g === void 0 ? void 0 : _g.description)
                : "".concat(responseQuote.data.productId.description);
            df.PlanTypeName = responseOneQuote
                ? "".concat((_j = (_h = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.planId) === null || _j === void 0 ? void 0 : _j.name)
                : "".concat(responseQuote.data.planId.name);
            df.CampaignName = responseOneQuote
                ? responseOneQuote &&
                    "".concat((_m = (_l = (_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.productId) === null || _l === void 0 ? void 0 : _l.campaign[0]) === null || _m === void 0 ? void 0 : _m.name)
                : "".concat(responseQuote.data.productId.campaign[0].name);
            df.CoverType = (_q = (_p = (_o = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _o === void 0 ? void 0 : _o.coverType) === null || _p === void 0 ? void 0 : _p.description) !== null && _q !== void 0 ? _q : "";
            df.PaymentMode =
                (_x = (_w = (_t = (_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.catalogPaymentMode) === null || _s === void 0 ? void 0 : _s.description) !== null && _t !== void 0 ? _t : (_v = (_u = responseQuote === null || responseQuote === void 0 ? void 0 : responseQuote.data) === null || _u === void 0 ? void 0 : _u.catalogPaymentMode) === null || _v === void 0 ? void 0 : _v.description) !== null && _w !== void 0 ? _w : findParamInLocalStorage("paymentModeName", "steps")) !== null && _x !== void 0 ? _x : "";
            df.Currency = isTravelInsurance
                ? "USD"
                : (_y = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data.lastPrice) === null || _y === void 0 ? void 0 : _y.currencySymbol;
            df.Prima = isTravelInsurance
                ? ((_0 = (_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.contentMap) === null || _0 === void 0 ? void 0 : _0.premium) != null
                    ? "USD ".concat(responseOneQuote.data.contentMap.premium)
                    : "0.00"
                : ((_1 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data.lastPrice) === null || _1 === void 0 ? void 0 : _1.amount)
                    ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                    : "0.00";
            df.QuoteId = responseOneQuote
                ? "".concat((_2 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _2 === void 0 ? void 0 : _2.id)
                : "".concat(responseQuote.data.id);
            setDataForm(df);
            setEmail((_4 = (_3 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _3 === void 0 ? void 0 : _3.email) !== null && _4 !== void 0 ? _4 : "");
            setInterval(function () {
                setShowModal(false);
            }, 5000);
            dispatch(quoteOneClearData());
        }
    }, [responseQuote, responseOneQuote]);
    console.log("!!quoteIdParam", !!quoteIdParam);
    return (_jsxs(React.Fragment, { children: [_jsx(PaymentConfirmationHeader, { hideStep: !!quoteIdParam, steps: steps2, responsePolicyConfirmLoading: responsePolicyConfirmLoading || loadingOneQuote, seeToast: seeToast, setSeeToast: setSeeToast }), showModal && !quoteIdParam && showSuccess(), _jsx(PaymentConfirmationView
            // steps={steps}
            , { 
                // steps={steps}
                responsePolicyConfirmLoading: responsePolicyConfirmLoading || loadingOneQuote, seeToast: seeToast, setSeeToast: setSeeToast, previousLabel: "Ver p\u00F3lizas", title: "Pago", onNext: handleNext, nextLabel: "Finalizar", section1Title: "Descarga de documentos", section1GeneratingTitle: "Generando documentos...", section2Title: "Enviar por correo", dataForm: dataForm, defaultEmail: email, 
                // stepProgress={steps}
                quoteId: quoteId || quote_id || quoteIdParam, initialCertificates: seedCertificates, filters: getDataFormFilters(dataForm), onBack: handlePrevious, onClickSendEmail: handleSendEmail, onClickDownload: handleDownload })] }));
};
export default PaymentConfirmation;
